/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { rpMediaQueries } from 'core/theme'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { BoxStore } from '../../stores/RussianPoker/Box.store'
import { ChipOnBAB } from './ChipOnBAB'
import { SeatBtnBox } from './SeatBtnBox'
import { SeatNumberBox } from './SeatNumberBox'
import { Container, ContainerWrapper, Inside } from './styles'

export const CompactBoxView: FC<{ box: BoxStore }> = observer((props) => {
  const { seatNumber, sendSelectedBox } = props.box
  const isPaidSeat = props.box.rootStore.stakedBoxes.some((box) => {
    return box.seatNumber !== seatNumber && Boolean(box.ante)
  })
  const paidAnte = props.box.rootStore.stakedBoxes[0]?.ante || 0

  return (
    <ContainerWrapper>
      <Container>
        <Inside
          css={css`
            padding-top: 8px;
            padding-bottom: 8px;

            ${rpMediaQueries.tablet} {
              padding-top: 15px;
              padding-bottom: 15px;
            }
          `}>
          {isPaidSeat && (
            <ChipOnBAB
              amount={paidAnte}
              showAmount={false}
              css={css`
                z-index: 1;
                position: absolute;
                top: 0;

                img {
                  width: 40px;
                  height: 40px;

                  ${rpMediaQueries.tablet} {
                    width: 70px;
                    height: 70px;
                  }
                }
              `}
            />
          )}
          <SeatNumberBox seatNumber={seatNumber} />
          <SeatBtnBox
            data-cy={`rp-take-box-btn-${seatNumber}`}
            onClick={() => {
              if (isPaidSeat) {
                props.box.sendPlaceAnte(paidAnte)
              } else {
                sendSelectedBox()
              }
            }}
            css={css`
              z-index: 2;
              position: relative;
            `}
          />
        </Inside>
      </Container>
    </ContainerWrapper>
  )
})
